import { useBreakpoint } from "~/shared";
import { tw } from "~/utils";

export const VisitSubtitle = () => {
  const { isMobile } = useBreakpoint();

  return (
    <p className={tw("text-indigo", !isMobile && "w-3/4")}>
      Check your email for a link to your pre-visit forms, which we ask you to
      complete at least 1 day ahead of your visit.
    </p>
  );
};
